import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HomeDiv = styled.div``;

export const HomeImagBox = styled.div`
  position: relative;
  margin-top: 107px;
  @media screen and (min-width: 1280px) {
    margin-top: 146px;
  }
`;

export const HomeImagTextBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const HomeImagTitile = styled.h1`
  color: #ffffff;
  font-family: 'Playfair Display', sans-serif;
  font-size: 29px;
  text-align: center;
  line-height: normal;
  width: 267px;
  margin-bottom: 50px;
  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const HomeImagLink = styled(Link)`
  background-color: rgba(255, 255, 255, 0.7);
  color: #000000;
  font-family: 'Playfair Display', sans-serif;
  text-decoration: none;
  font-size: 22px;
  line-height: normal;
  padding: 15px 40px;
  border-radius: 8px;
  transition: all 150ms linear;
  @media screen and (min-width: 768px) {
    font-size: 26px;
    padding: 20px 59px;
  }

  &:hover,
  &:focus {
    background-color: transparent;
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.7);
  }
`;

export const HomeImag = styled.img`
  width: 100%;
  box-shadow: inset 0px 4px 10px rgba(0, 0, 0, 0.5);
  object-fit: cover;
  &:nth-child(1) {
    display: none;
    @media screen and (min-width: 1280px) {
      display: block;
    }
  }

  &:nth-child(2) {
    display: none;
    @media screen and (min-width: 768px) and (max-width: 1279.98px) {
      display: block;
    }
  }

  &:nth-child(3) {
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
    }
  }
`;

export const HomeMenu = styled.div`
  margin-top: 70px;
  margin-bottom: 70px;
`;

export const HomeMenuTitle = styled.h2`
  color: black;
  font-family: 'Playfair Display', sans-serif;
  font-size: 29px;
  text-align: center;
  line-height: normal;
  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const HomeMenuList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 25px;
  margin-top: 50px;
`;

export const HomeMenuListItem = styled.li`
  width: 333px;
  border: 1px solid #a4907c;
  border-radius: 8px;
  padding: 20px;
`;

export const MenuDay = styled.p`
  color: black;
  font-family: 'Aboreto', sans-serif;
  font-size: 17px;
  text-align: center;
  line-height: normal;

  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

export const MenuItemBox = styled.div`
  margin-top: 20px;

  @media screen and (min-width: 768px) {
    margin-top: 30px;
  }
`;

export const MenuItem = styled.p`
  color: black;
  font-family: 'Playfair Display', sans-serif;
  font-size: 24px;
  text-align: center;
  line-height: normal;
  &:not(:first-child) {
    margin-top: 6px;
  }

  @media screen and (min-width: 768px) {
    font-size: 26px;
  }
`;

export const HomePhoto = styled.div`
  margin-bottom: 70px;
`;

export const SliderBox = styled.div`
  margin-top: 50px;
`;

export const SliderImg = styled.img`
  width: 250px;

  @media screen and (min-width: 768px) {
    width: 350px;
  }

  @media screen and (min-width: 1280px) {
    width: 400px;
  }
`;

export const HomeEvents = styled.div`
  margin-top: 70px;
  margin-bottom: 70px;
`;

export const EventsBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  gap: 15px;
`;

export const EventsImg = styled.img`
  width: 250px;

  @media screen and (min-width: 768px) {
    width: 350px;
  }

  @media screen and (min-width: 1280px) {
    width: 400px;
  }
`;

// export const HomeDiv = styled.div``;
// export const HomeDiv = styled.div``;
